// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProviderPicker-module__root___MGEQr {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.ProviderPicker-module__label___f3vLe {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #71717a;
}

.ProviderPicker-module__picker___LM0aa {
  position: relative;
}

.ProviderPicker-module__trigger___LszOf {
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  background: #ffffff;
  color: #18181b;
  cursor: pointer;
}
.ProviderPicker-module__trigger___LszOf:hover:not(:disabled) {
  border-color: #18181b;
}
.ProviderPicker-module__trigger___LszOf:focus-visible {
  outline: 2px solid #a1a1aa;
  outline-offset: 2px;
}
.ProviderPicker-module__trigger___LszOf:disabled {
  cursor: default;
}

.ProviderPicker-module__avatar___FGb9S {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background: #18181b;
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
}

.ProviderPicker-module__name____tqCk {
  font-size: 16px;
  font-weight: 600;
}

.ProviderPicker-module__count___A8NRw {
  font-size: 13px;
  font-weight: 400;
  color: #71717a;
}

.ProviderPicker-module__chevron___wbplx {
  color: #71717a;
  flex-shrink: 0;
}

.ProviderPicker-module__dropdown___sj6x5 {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 50;
  min-width: 300px;
  max-height: 360px;
  overflow-y: auto;
  padding: 4px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.ProviderPicker-module__option___WNmR_ {
  font-family: inherit;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  text-align: left;
  cursor: pointer;
}
.ProviderPicker-module__option___WNmR_:hover {
  background: #f4f4f5;
}

.ProviderPicker-module__optionActive___mZlWg {
  background: #fafafa;
}

.ProviderPicker-module__check___gMdlO {
  display: inline-flex;
  width: 14px;
  flex-shrink: 0;
  color: #18181b;
}

.ProviderPicker-module__optionName___qStu8 {
  font-size: 14px;
  font-weight: 500;
  color: #18181b;
}

.ProviderPicker-module__optionName___qStu8 + .ProviderPicker-module__count___A8NRw {
  margin-left: auto;
  padding-left: 16px;
}

.ProviderPicker-module__panel___SFgrl {
  flex-wrap: nowrap;
  gap: 8px;
}
.ProviderPicker-module__panel___SFgrl .ProviderPicker-module__label___f3vLe {
  flex-shrink: 0;
  font-size: 11px;
}
.ProviderPicker-module__panel___SFgrl .ProviderPicker-module__picker___LM0aa {
  flex: 1 1 auto;
  min-width: 0;
}
.ProviderPicker-module__panel___SFgrl .ProviderPicker-module__trigger___LszOf {
  width: 100%;
  min-width: 0;
  padding: 6px 10px;
}
.ProviderPicker-module__panel___SFgrl .ProviderPicker-module__name____tqCk {
  min-width: 0;
  overflow: hidden;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ProviderPicker-module__panel___SFgrl .ProviderPicker-module__count___A8NRw {
  flex-shrink: 0;
}
.ProviderPicker-module__panel___SFgrl .ProviderPicker-module__dropdown___sj6x5 {
  right: 0;
  min-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/ProviderPicker.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACF;AACE;EACE,qBAAA;AACJ;AAEE;EACE,0BAAA;EACA,mBAAA;AAAJ;AAGE;EACE,eAAA;AADJ;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,cAAA;AAFF;;AAKA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;AAFF;;AAKA;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAFF;AAIE;EACE,mBAAA;AAFJ;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,oBAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAHF;;AAMA;EACE,iBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,QAAA;AAHF;AAKE;EACE,cAAA;EACA,eAAA;AAHJ;AAME;EACE,cAAA;EACA,YAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AALJ;AAQE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AANJ;AASE;EACE,cAAA;AAPJ;AAUE;EACE,QAAA;EACA,YAAA;AARJ","sourcesContent":[".root {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.label {\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #71717a;\n}\n\n.picker {\n  position: relative;\n}\n\n.trigger {\n  font-family: inherit;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  border: 1px solid #d4d4d8;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #18181b;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: #18181b;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #a1a1aa;\n    outline-offset: 2px;\n  }\n\n  &:disabled {\n    cursor: default;\n  }\n}\n\n.avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 26px;\n  height: 26px;\n  border-radius: 999px;\n  background: #18181b;\n  color: #ffffff;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.name {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.count {\n  font-size: 13px;\n  font-weight: 400;\n  color: #71717a;\n}\n\n.chevron {\n  color: #71717a;\n  flex-shrink: 0;\n}\n\n.dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  z-index: 50;\n  min-width: 300px;\n  max-height: 360px;\n  overflow-y: auto;\n  padding: 4px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.option {\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n\n  &:hover {\n    background: #f4f4f5;\n  }\n}\n\n.optionActive {\n  background: #fafafa;\n}\n\n.check {\n  display: inline-flex;\n  width: 14px;\n  flex-shrink: 0;\n  color: #18181b;\n}\n\n.optionName {\n  font-size: 14px;\n  font-weight: 500;\n  color: #18181b;\n}\n\n.optionName + .count {\n  margin-left: auto;\n  padding-left: 16px;\n}\n\n.panel {\n  flex-wrap: nowrap;\n  gap: 8px;\n\n  .label {\n    flex-shrink: 0;\n    font-size: 11px;\n  }\n\n  .picker {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .trigger {\n    width: 100%;\n    min-width: 0;\n    padding: 6px 10px;\n  }\n\n  .name {\n    min-width: 0;\n    overflow: hidden;\n    font-size: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .count {\n    flex-shrink: 0;\n  }\n\n  .dropdown {\n    right: 0;\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ProviderPicker-module__root___MGEQr`,
	"label": `ProviderPicker-module__label___f3vLe`,
	"picker": `ProviderPicker-module__picker___LM0aa`,
	"trigger": `ProviderPicker-module__trigger___LszOf`,
	"avatar": `ProviderPicker-module__avatar___FGb9S`,
	"name": `ProviderPicker-module__name____tqCk`,
	"count": `ProviderPicker-module__count___A8NRw`,
	"chevron": `ProviderPicker-module__chevron___wbplx`,
	"dropdown": `ProviderPicker-module__dropdown___sj6x5`,
	"option": `ProviderPicker-module__option___WNmR_`,
	"optionActive": `ProviderPicker-module__optionActive___mZlWg`,
	"check": `ProviderPicker-module__check___gMdlO`,
	"optionName": `ProviderPicker-module__optionName___qStu8`,
	"panel": `ProviderPicker-module__panel___SFgrl`
};
module.exports = ___CSS_LOADER_EXPORT___;
